<template>
  <section class="contact section" id="contact">
    <div class="container">
      <div class="row">
        <div class="col">
          <h1>
            <span class="firstTitle">{{ $t('contact') }}</span>
            <span class="secondTitle">{{ $t('contact_us') }}</span>
          </h1>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <p>
            <img src="../assets/email.png" alt="email" id="email" class="email">
            <a href="mailto:skear.contact@gmail.com">skear.contact@gmail.com</a>
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <a class="icon" href="https://www.facebook.com/SkearGames" target="_blank">
            <span>
              <i class="fab fa-facebook-square"></i>
            </span>
          </a>
          <a class="icon" href="https://twitter.com/SkearGames" target="_blank">
            <span>
              <i class="fab fa-twitter-square"></i>
            </span>
          </a>
          <a class="icon" href="https://www.instagram.com/skear.games" target="_blank">
            <span>
              <i class="fab fa-instagram"></i>
            </span>
          </a>
          <a class="icon" href="https://www.youtube.com/channel/UCNzqX19JDStQ04GIJ6e8tbA " target="_blank">
            <span>
              <i class="fab fa-youtube-square"></i>
            </span>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Contact",
  props: {
    msg: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.contact {
  img {
    width: 30px;
    margin: 10px 10px 10px 0;
  }
  a {
    color: #62bedb;
    &:hover {
      text-shadow: #0089ff 1px 0 10px;
    }
  }
  .icon {
    margin: 0 10px;
    span{
      font-size: 3em;
      color: white;
      &:hover{
        color: #62bedb;
      }
    }
  }
}
</style>
